import script from "./WoononPhaseTotal.vue?vue&type=script&lang=ts&setup=true"
export * from "./WoononPhaseTotal.vue?vue&type=script&lang=ts&setup=true"

import "./WoononPhaseTotal.vue?vue&type=style&index=0&id=2a935bc7&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a935bc7"]])

export default __exports__